module.exports = __webpack_public_path__ + "static/media/logo-mp.ef416d10.png";